import { useRef } from 'react';
import Players from 'components/3catinfo/Players';
import clsx from 'clsx';
import styles from '../cosminutaminut.module.scss';

const Audio = (props) => {
    const { id } = props;
    const playerRef = useRef();

    const stylesMedia = clsx({
        [styles.media]: true,
        [styles.mediaAudio]: true
    });

    return (
        <div className={stylesMedia} data-testid='cos-minutaminut-media-audio'>
            <div className={styles.audio}>
                <Players ref={playerRef} tipus='audioNoti' id={id} playerVideoTagId={`audio-noticia-${id}`} />
            </div>
        </div>
    );
};

export default Audio;
